import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export type DistributionSummaryPeriod = "1_month" | "3_month" | "6_month";

export interface DistributionSummaryResponse {
  success?: boolean;
  message?: string;
  data?: Record<string, unknown>;
}

export interface CustomSummaryPayload {
  period: "custom";
  startDate: string;
  endDate: string;
}

export interface OrganizationDistributionRequest {
  id?: string;
  _id?: string;
  organizationName?: string;
  orgId?: string;
  ownerId?: string;
  owner?: {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  };
  requestType?: string;
  currency?: string;
  reason?: string;
  status?: string;
  reviewedAt?: string | null;
  adminNotes?: string | null;
  reviewedBy?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface DistributionRequestsPagination {
  page?: number;
  limit?: number;
  total?: number;
  totalPages?: number;
}

interface DistributionRequestsResponse {
  success?: boolean;
  data?:
    | OrganizationDistributionRequest[]
    | {
        requests?: OrganizationDistributionRequest[];
        distributionRequests?: OrganizationDistributionRequest[];
        pagination?: DistributionRequestsPagination;
      };
}

export interface DistributionRequestsResult {
  requests: OrganizationDistributionRequest[];
  pagination: DistributionRequestsPagination | null;
}

export const adminDistributionReportingService = {
  getSummary: async (period: DistributionSummaryPeriod) => {
    const response = await apiClient.get<DistributionSummaryResponse>(
      ENDPOINTS.ADMIN.DISTRIBUTIONS_SUMMARY,
      { params: { period } }
    );
    return response.data;
  },
  getCustomSummary: async (payload: CustomSummaryPayload) => {
    const response = await apiClient.post<DistributionSummaryResponse>(
      ENDPOINTS.ADMIN.DISTRIBUTIONS_SUMMARY,
      payload
    );
    return response.data;
  },
  getDistributionRequests: async (params?: {
    requestType?: "all" | "grant_fund" | "token_distribution";
    page?: number;
    limit?: number;
  }): Promise<DistributionRequestsResult> => {
    const queryParams = {
      ...params,
      requestType: params?.requestType === "all" ? undefined : params?.requestType,
    };
    const response = await apiClient.get<DistributionRequestsResponse>(
      ENDPOINTS.ADMIN.ORGANIZATION_DISTRIBUTION_REQUESTS,
      { params: queryParams }
    );
    const payload = response.data?.data;
    if (Array.isArray(payload)) {
      return {
        requests: payload,
        pagination: null,
      };
    }
    const requests = Array.isArray(payload?.requests)
      ? payload.requests
      : Array.isArray(payload?.distributionRequests)
        ? payload.distributionRequests
        : [];
    return {
      requests,
      pagination: payload?.pagination ?? null,
    };
  },
};

export default adminDistributionReportingService;
